import React from 'react';

function Testimonials({ isMobile }) {
  const testimonials = [
    {
      text: "The pork from Sir Henry's is always fresh and of excellent quality. I've been a loyal customer for years!",
      name: "John M.",
      role: "Restaurant Owner"
    },
    {
      text: "Best prices for wholesale pork in Chitungwiza. Their service is reliable and the meat is always top-notch.",
      name: "Sarah T.",
      role: "Catering Business"
    },
    {
      text: "I appreciate their flexible pricing for loyal customers. The quality is consistent and the staff is friendly.",
      name: "David K.",
      role: "Regular Customer"
    }
  ];

  return (
    <section id="testimonials" className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <h2 className={`text-center font-bold text-gray-900 mb-12 ${isMobile ? 'text-3xl' : 'text-4xl'}`}>
          What Our Customers Say
        </h2>
        <div className={`grid ${isMobile ? 'grid-cols-1' : 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3'} gap-8`}>
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white p-8 rounded-xl shadow-lg">
              <div className="mb-6">
                <p className="text-gray-600 italic">"{testimonial.text}"</p>
              </div>
              <div className="border-t pt-4">
                <h4 className="font-bold text-gray-900">{testimonial.name}</h4>
                <p className="text-yellow-600 font-semibold">{testimonial.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Testimonials;